import React from 'react';
import { ServiceAreaSectionEditStyled } from './ServiceAreaSectionEdit.styled';
import { SectionEditHeader } from '../SectionEditHeader/SectionEditHeader';
import { ServiceAreaForm } from '../../ServiceAreaForm/ServiceAreaForm';
import { useWebstoreContext } from 'vendor/contexts/WebstoreContext/WebstoreContext';

const ServiceAreaSectionEdit = () => {
    const { webstore } = useWebstoreContext();

    return (
        <ServiceAreaSectionEditStyled className="section-header">
            <SectionEditHeader
                title="Forms.ServiceArea.LocationTitle"
                description="Forms.ServiceArea.LocationDescription"
            />
            <ServiceAreaForm webstore={webstore} showOnlineOptions={true} />
        </ServiceAreaSectionEditStyled>
    );
};

export { ServiceAreaSectionEdit };
